export default (bottle) => {
  bottle.factory('setTimeout', () => setTimeout);

  bottle.factory('sleep', ({ setTimeout }) => time => new Promise(resolve => setTimeout(() => resolve(), time)));

  bottle.factory('localStorage', ({ window }) => (window ? window.localStorage : null));

  bottle.factory('session', ({ getSession, clearSession, setSession }) => ({
    set: setSession,
    get: getSession,
    clear: clearSession,
  }));

  bottle.factory('getSession', ({ localStorage }) => function getSession() {
    if (!localStorage) return undefined;
    const accessToken = localStorage.getItem('accessToken');
    const idToken = localStorage.getItem('idToken');
    let expiresIn = localStorage.getItem('expiresIn');

    try {
      expiresIn = JSON.parse(expiresIn);
    } catch (err) {
      console.log('cannot parse expiresIn', expiresIn);
    }

    if (accessToken && idToken && expiresIn) {
      return {
        accessToken,
        idToken,
        expiresIn,
      };
    }
    return undefined;
  });

  bottle.factory('clearSession', ({ localStorage }) => function clearSession() {
    if (!localStorage) return;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('expiresIn');
  });

  bottle.factory('setSession', ({ localStorage, clearSession }) => function setSession(params) {
    if (!localStorage) return undefined;
    if (!(params && (typeof params === 'object'))) {
      console.log('bad session:', params);
      return clearSession();
    }
    const { accessToken, idToken, expiresIn } = params;

    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('idToken', idToken);
    try {
      localStorage.setItem('expiresIn', JSON.stringify(expiresIn));
    } catch (err) {
      console.log('cannot stringify expiresIn ', expiresIn);
    }

    return {
      accessToken,
      idToken,
      expiresIn,
    };
  });
};



// WEBPACK FOOTER //
// ./src/session.js